const me = {
  slug: 'f/me',
  changePassword: () => `${me.slug}/password`,
  deactivateUserProfile: () => `${me.slug}/profile/deactivate`,
  resetPassword: () => `${me.slug}/password/reset`,
  confirmPassword: () => `${me.slug}/password/confirm`,
  uploadProfilePhoto: () => `${me.slug}/profile/photo`,
  requestUserProfileReactivation: () => `${me.slug}/profile/reactivation/email`,
  reactivateUserProfile: () => `${me.slug}/profile/reactivation/email/confirm`,
  confirmBecomeAContributorFlow: () =>
    `${me.slug}/promotion/contributor/confirm`,
  confirmBecomeASponsoredContributorFlow: () =>
    `${me.slug}/promotion/sponsored-contributor/confirm`,
  reactivateFacebookUserProfile: () =>
    `${me.slug}/profile/reactivation/facebook`,
  reactivateTwitterUserProfile: () => `${me.slug}/profile/reactivation/twitter`,
  reactivateGoogleUserProfile: () => `${me.slug}/profile/reactivation/google`,
  getProfileBasicInfo: () => `${me.slug}/profile/basic`,
  getNotifications: () => `${me.slug}/articles/notifications`,
  clearAllNotifications: () => `${me.slug}/articles/notifications/all`,
  updateAnnouncementSubscriptionPreferences: () =>
    `${me.slug}/announcements/preferences`,
  getAnnouncementSubscriptionPreferences: () =>
    `${me.slug}/announcements/preferences`,
  getAnnouncements: () => `${me.slug}/announcements`,
  deleteAnnouncement: announcementId =>
    `${me.slug}/announcements/${announcementId}`,
  clearAllAnnouncements: () => `${me.slug}/announcements/all`,
  getProfileSummary: () => `${me.slug}/profile/counters`,
  getBellIconItems: () => `${me.slug}/bell-icon/notifications`,
  markReadBellIcon: () => `${me.slug}/bell-icon/notifications/read`,
  deleteBellIconItem: () => `${me.slug}/bell-icon/notifications`,
  clearAllBellIcon: () => `${me.slug}/bell-icon/notifications/all`
}

export default me
